export const STEPS = [
  { id: 1, title: "Category" },
  { id: 2, title: "Product" },
  { id: 3, title: "Question" },
  { id: 4, title: "Review" }
];

export const STEP_CONFIG = {
  1: {
    title: "Select Category",
    description: "" // Empty description
  },
  2: {
    title: "Select Product", 
    description: "" // Empty description
  },
  3: {
    title: "Ask a Question",
    description: "" // Empty description
  },
  4: {
    title: "Review Your Search",
    description: "" // Empty description
  }
};